import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useFetchItems from "../../hooks/useFetchItems";
import { homeSafetyCols } from "./AllColumsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useChangeHandler from "../../hooks/useChangeHandler";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const MODULE_NAMES = [
  "Home Safety And Security",
  "Utility Shutoff Locations",
  "Emergency Equipment Locations",
  "Security System Details",
];

export default function HomeSafetyAndSecurity() {
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Home Safety And Security");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(MODULE_NAMES, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading);
  const { attributes, disasterAttribute } = useGetAttributes(MODULE_NAMES, setLoading);
  const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setFormData,
    setAttributesData
  );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  console.log("attributessss", attributes);

  const collapseableTables = [
    { title: "Utility Shutoff Locations", key: 1 },
    { title: "Emergency Equipment Locations", key: 2 },
    { title: "Security System Details", key: 3 },
  ];
  const tableDataObj = {
    "Utility Shutoff Locations": tableData.utilityShutoffLocationsData,
    "Emergency Equipment Locations": tableData.emergencyEquipmentLocationsData,
    "Security System Details": tableData.securitySystemDetailsData,
  };
  const AllColumnsData = homeSafetyCols(viewModal, updateModal, deleteRecord);

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Home Safety And Security</h2>
        <ToolTipCreator name={"Disaster_Home_Safety_Security"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      {collapseableTables.map((table, idx) => (
        <CollapseableTable title={table.title} key={table.key} onClick={showModal}>
          <Table columns={AllColumnsData[table.title]} dataSource={tableDataObj[table.title]} />
        </CollapseableTable>
      ))}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
}
